<template>
  <div>
    <div class="banner">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082702213142.jpg"></el-image>
      <div class="cover">
        <h1>手套资讯</h1>
        <div class="subtitle">新闻中心</div>
      </div>
    </div>
    <div class="list">
      <el-row :gutter="50">

        <el-col :span="8" v-for="(item,index) in tableData" :key="index">
          <router-link :to="{path:'/news-detail',query:{id:item.id}}">
            <div class="item">
              <div class="new-info">
                <el-image :src="item['coverUrl']"></el-image>
              </div>
              <div class="desc">
                <div class="time">{{ item['strShowTime'] }}</div>
                <div class="title"><a href="">{{ item['title'] }}</a></div>
              </div>
            </div>
          </router-link>
        </el-col>
      </el-row>
    </div>
    <div class="page">
      <el-pagination
          layout="prev, pager, next"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
import {getArticleList} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      form: {
        classNo: "AC1010"
      },
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 9
    }
  },
  created() {
    this.getList();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    getList() {
      getArticleList(this.form, this.currentPage, this.pageSize).then((res) => {
        this.tableData = res["data"];
        this.total = res["total"];
      });
    },
  }
}
</script>

<style scoped>
@import url("Index.css");
</style>